import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cx from 'classnames';


import Modal, { ModalContent, ModalHeader, ModalTitle, ModalActions } from 'components/Modal';
import { ConfirmType } from 'constants/constants';
import Button, { SaveButton } from 'components/Button';
import Form from 'components/forms/Form';

// ===========================
// COMPONENT
// ===========================
export class FormModal extends React.Component {
  state = {
    values: {},
    edits: {},
    errors: {},
    defaults: {},
    files: {},
  }

  componentDidMount() {
    this.setState({
      values: _.reduce(this.props.inputs, (o,v,k) => _.set(o, k, v?.props.value), {}),
      defaults: _.reduce(this.props.inputs, (o,v,k) => _.set(o, k, v?.props.value), {}),
      edits: _.reduce(this.props.inputs, (o,v,k) => _.set(o, k, false), {}),
    })
  }

  onChange = (value, name, e, file) => {
    this.setState({
      values: { ...this.state.values,
        [name]: value
      },
      edits: { ...this.state.edits,
        [name]: this.state.defaults[name] !== value
      },
      errors: _.omit(this.state.errors, name),
    })
    if(file){
      this.setState({
          files: { ...this.state.files,
            [name]: file
          }
        });
    }
  }
  
  onSave = () => {
    this.props.onSave?.(
      this.state.values, 
      this.state.edits, 
      this.state.files, 
      this.state.errors);
    this.props.onClose();
  }

  render() {
    let { inputs, buttonText, title, className, confirmType = ConfirmType.DEFAULT, onClose } = this.props;
    let { values } = this.state;

    let confirmButton;
    switch(confirmType) {
      case ConfirmType.SAVE:
        confirmButton = <SaveButton size="l" onClick={this.onSave} variant="success">{ buttonText }</SaveButton>;
        buttonText = "Save";
        break;
      default:
        confirmButton = <Button size="l" onClick={this.onSave}>{ buttonText }</Button>;
        buttonText = "Done";
    }
    return (
    <Modal className={cx("form", className)} onClose={onClose} keyboard={false}>
      <ModalHeader>
        <ModalTitle>{title}</ModalTitle>
      </ModalHeader>
      <ModalContent>
      
        {
          _.map(inputs, (data, name) => {
            let { component: Input, props } = data;
            return (
              <Input 
                key={name}
                name={name}
                {..._.omit(props, 'value')}
                value={values[name]}
                onChange={this.onChange}
                onSubmit={this.onSave} />)
          })
        }
      
        
      </ModalContent>
      <ModalActions>
        { confirmButton }
      </ModalActions>
    </Modal>)
  }
}
export default FormModal;